import {
  DTOFormatDestinations,
  handleAdditionalAssetsBannerVideo,
  mapAgeRestrictedSetting,
  mapToCampaignProducts,
  handleSubpublishers
} from '../../../helpers'
import { deserializeKeywords } from '~/modules/retailMedia/helpers/keywords'

export const DTOCreateBannerVideoCampaign = (
  data: DTOCreateBannerVideoCampaignPayload
) => {
  const costType = data?.cost?.cost_type || 'cpmcpc'
  /**
   * Handle banner config
   */
  const bannerData: DTOCreateBannerCampaignConfig = {
    keywords: deserializeKeywords(data.targeting?.keywords),
    categories: data.targeting?.categories?.split(',') || null,
    assets: data.banners.map(item => ({
      ad_size: item.ad_size,
      alt_text: item.alt_text,
      media_url: item.media_url
    }))
  }

  if (data.settings?.destination_url) {
    bannerData.destination_url = data.settings?.destination_url || null
  }

  if (data.settings?.destinations) {
    bannerData.destinations = DTOFormatDestinations(data.settings?.destinations)
  }

  /**
   * Handle products linkded to campaign
   */

  const products = mapToCampaignProducts(data?.products || [])

  /*
   * Handle budget
   */
  const { lengthCentsCurrency } = data

  const dailyCostRaw = data.settings?.daily_cost?.numAsString
  const dailyCost = lengthCentsCurrency
    ? Number(dailyCostRaw) / 100
    : Number(dailyCostRaw)

  const cpmRaw = data.budget?.cpm?.numAsString
  const cpm = lengthCentsCurrency ? Number(cpmRaw) / 100 : Number(cpmRaw)

  const dailyBudgetRaw = data.budget?.daily?.numAsString
  const dailyBudget = lengthCentsCurrency
    ? Number(dailyBudgetRaw) / 100
    : Number(dailyBudgetRaw)

  const budget = {
    daily_budget: dailyBudget,
    dailyCost,
    cpm
  }

  const costsByType = {
    cpmcpc: () => ({
      daily_budget: budget.daily_budget,
      cpm: budget.cpm
    }),
    daily_cost: () => ({
      daily_cost: budget.dailyCost
    })
  }

  /**
   * Handle campaign settings
   */

  const settings: DTOCreateBannerCampaignSettings = {
    products,
    ...costsByType[costType](),
    ...mapAgeRestrictedSetting(data?.settings)
  }

  if (data?.placements?.placementsCheck === 'selected') {
    const placements = data?.placements?.placements_ids
    const selectedPlacements = Object.values(placements).filter(
      values => values.checked
    )

    settings.placements = selectedPlacements.map(({ value: id }) => ({ id }))
  }

  if (data?.settings?.budget_type) {
    settings.budget_type = data.settings.budget_type
  }

  let body: DTOCreateBannerVideoCampaignResponse = {
    publisher_id: data?.publisher_id,

    audience_id: data?.audience
      ? (Number(data.audience) as AudienceData['id'])
      : null,

    name: data.name,
    description: data?.description,

    type: 'on_site',
    ad_type: 'banner_video',

    start_at: data.start_date,
    end_at: data?.end_date || null,

    banner: { ...bannerData },

    settings
  }

  const totalBudgetRaw = data.budget?.total?.numAsString

  if (totalBudgetRaw) {
    const total_budget = lengthCentsCurrency
      ? Number(totalBudgetRaw) / 100
      : Number(totalBudgetRaw)

    body.total_budget = total_budget
  }

  body = handleAdditionalAssetsBannerVideo({
    body,
    data
  })

  body = handleSubpublishers<DTOCreateBannerVideoCampaignResponse>({
    body,
    data
  })

  return body
}
